import { useCallback } from "react";

import { TreePicklistItemResponse } from "../TreePicklistItemProvider";
import { TreePicklistItem } from "../TreePicklistItem";

import { PicklistModalProps } from "./TreePicklistModal";

export const useTreePicklistItemFabric = (props: PicklistModalProps) =>
    useCallback(
        (item: TreePicklistItemResponse, ancestors: TreePicklistItemResponse[]) =>
            new TreePicklistItem({
                item: item,
                ancestors: ancestors,
                parentColumnName: props.parentColumnName,
                childColumnName: props.childColumnName,
                minPickLevel: props.minPickLevel,
                allowedToPickLevels: props.allowedToPickLevels,
                fieldToDisableElementPick: props.fieldToDisableElementPick,
                treeQuery: props.treeQuery,
            }),
        [props.parentColumnName, props.childColumnName, props.minPickLevel, props.treeQuery]
    );
